/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1BannerId202,
  DeleteApiV1BannerId401,
  DeleteApiV1BannerId404,
  DeleteApiV1BannerId500,
  DeleteApiV1BannerIdMutationResponse,
  DeleteApiV1BannerIdPathParams,
} from "../../types/bannerRegistroController/DeleteApiV1BannerId.ts";

export const deleteApiV1BannerIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1BannerIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1BannerId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1BannerId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1BannerId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1BannerId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1BannerId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1BannerId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1BannerId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1BannerId500>;

export const deleteApiV1BannerIdMutationResponseSchema = z.lazy(
  () => deleteApiV1BannerId202Schema,
) as unknown as ToZod<DeleteApiV1BannerIdMutationResponse>;
